import { ErrorLine } from "../components/ui";
import { useState, type FormEvent } from "react";
import { supabase } from "../lib/supabase";
import { useAuth } from "../lib/auth";
import { Logo } from "../components/Logo";

export function ResetPassword() {
  const { clearRecovery, signOut } = useAuth();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  async function submit(e: FormEvent) {
    e.preventDefault(); setErr(null);
    if (pw.length < 6) { setErr("Password must be at least 6 characters."); return; }
    if (pw !== pw2) { setErr("The two passwords don't match."); return; }
    setBusy(true);
    const { error } = await supabase.auth.updateUser({ password: pw });
    setBusy(false);
    if (error) { setErr(error.message); return; }
    setDone(true);
  }

  return (
    <div className="min-h-screen grid place-items-center bg-bg">
      <div className="bg-surface border border-border rounded-xl2 shadow-sm w-[360px] p-6 flex flex-col gap-3">
        <div className="flex items-center gap-2.5 font-extrabold text-lg tracking-tight mb-1"><Logo /> Orator</div>
        {done ? (<>
          <p className="text-muted text-sm">Your password has been updated.</p>
          <button onClick={clearRecovery} className="mt-1 bg-accent text-white rounded-lg px-3.5 py-2.5 font-bold">Continue</button>
        </>) : (<>
          <p className="text-muted text-sm mb-1">Set a new password for your account.</p>
          <form onSubmit={submit} className="flex flex-col gap-3">
            <input type="password" required placeholder="New password" value={pw} onChange={(e) => setPw(e.target.value)} className="w-full bg-surface-2 border border-border rounded-lg px-3 py-2 text-text outline-none" />
            <input type="password" required placeholder="Re-type new password" value={pw2} onChange={(e) => setPw2(e.target.value)} className="w-full bg-surface-2 border border-border rounded-lg px-3 py-2 text-text outline-none" />
            <ErrorLine message={err} />
            <button type="submit" disabled={busy} className="mt-1 bg-accent text-white rounded-lg px-3.5 py-2.5 font-bold disabled:opacity-60">{busy ? "Saving…" : "Set password"}</button>
            <button type="button" onClick={() => { clearRecovery(); signOut(); }} className="text-sm text-text font-semibold underline underline-offset-2">Cancel</button>
          </form>
        </>)}
      </div>
    </div>
  );
}
